<template>
    <div class="info-box">
        <p class="title">{{title}}</p>
        <div class="row-box">
          <div
            v-for="(item,index) in newData"
            :key="index"
            class="row"
            :class="{fullLine: item.fullLine}"
          >
            <span class="name">{{item.key}}</span>
            <img
              v-if="item.type === 'image' && item.disabled"
              class="image"
              :src="item.value"
              alt="" />
            <ElementForm
              class="image"
              v-else-if="item.type === 'image'"
              :form.sync="form1"
              @onAttr="onAttr"
            />
            <div class="edit-box" v-else-if="item.type==='edit'">
                <span
                    v-if="!item.edit"
                    class="value">{{item.value}}</span>
                <span
                    v-if="!item.edit"
                    class="edit iconfont icon-pen"
                    @click="edit(item, index)"
                ></span>
                <el-input
                        v-if="item.edit"
                        class="input"
                        size="small"
                        v-model="item.value"
                ></el-input>
                <span v-if="item.edit" class="btns">
                    <span
                        class="btn save"
                        @click="save(item, index)"
                    >保存</span>
                    <span
                        class="btn cancel"
                        @click="cancel(item, index)"
                    >取消</span>
                </span>
            </div>
            <div
                v-else-if="item.type === 'dropSelect'"
                class="select-box"
            >
                <ElementForm
                    class="select"
                    :form.sync="item.form"
                    @onAttr="onAttr"
                />
            </div>
            <span v-else class="value">{{item.value}}</span>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'info',
    props: {
        title: String,
        data: Array
    },
    watch: {
        data: {
            handler(vl){
                try {
                    if (vl && vl.length > 0) {
                        const coverIndex = this.$utils.getIndexByAttr({attr: 'cover', data: this.form1})
                        const imageIndex = this.$utils.getIndexByAttr({attr: 'cover', data: vl})
                        this.form1[coverIndex].value = vl[imageIndex].value
                        if (vl[imageIndex].disabled) this.form1[coverIndex].props.disabled = true
                    }
                    this.newData = vl
                } catch (e) {
                    console.log('等待获取info->data==>', e)
                }
            },
            deep: true,
            immediate: true
        },
        newData: {
            handler (vl) {
                this.$emit('update:data', vl)
            },
            deep: true,
            immediate: true
        }
    },
    data () {
      return {
          isEditing: false, // 是否点击编辑
          newData: this.data,
          form1: [
              {
                  "attr": "cover",
                  "name": "",
                  "value": "",
                  "type": "SelectImage",
                  "props": {
                      "rules": {
                          "required": false,
                          "message": "请选择",
                          "target": "blur"
                      }
                  },
                  "status": "1"
              }
          ]
      }
    },
    methods: {
        edit(item, index){
            console.log('edit==>', item, index)
            let data = this.$_.cloneDeepWith(this.newData)
            data[index].edit = true;
            data[index].oldValue = item.value;
            this.newData = data

            // 正在编辑时禁止 onAttr事件执行
            this.isEditingGo()
        },
        isEditingGo(){
            this.isEditing = true
            const fn = setTimeout(()=>{
                this.isEditing = false
                clearTimeout(fn)
            }, 500)
        },
        save(item, index){
            if(!item.value || !item.value.trim()) {
                this.$message.error('修改不能为空')
                return false
            }
            let data = this.$_.cloneDeepWith(this.newData)
            data[index].edit = false;
            this.newData = data
            console.log(data[index].item)
            this.inputChange(data[index])

            // 正在编辑时禁止 onAttr事件执行
            this.isEditingGo()
        },
        cancel(item, index) {
            let data = this.$_.cloneDeepWith(this.newData)
            data[index].edit = false;
            data[index].value = data[index].oldValue;
            this.newData = data

            // 正在编辑时禁止 onAttr事件执行
            this.isEditingGo()
        },
        inputChange(item){
            this.$emit('onInput', item)
        },
        onAttr(obj){
            if(this.isEditing) return false
            console.log('onAttr==>', obj)
            switch (obj.attr) {
                case 'cover': {

                    const coverIndex = this.$utils.getIndexByAttr({attr: 'cover', data: this.form1})
                    this.$emit('onInput', this.form1[coverIndex])

                    const coverIndex2 =  this.$utils.getIndexByAttr({attr: 'cover', data: this.newData})
                    this.newData[coverIndex2].value = this.form1[coverIndex].value
                    break
                }
                case 'subject_id': {
                    // 学科改变后
                    // 1.刷新分类列表
                    // 2.清空分类选中
                    const category_id_index = this.$utils.getIndexByAttr({attr: 'category_id', data: this.newData})
                    const data = this.$_.cloneDeepWith(this.newData[category_id_index].form)
                    const subjectIdIndex = this.$utils.getIndexByAttr({attr: 'subject_id', data})
                    let categoryIdOptions = []
                    data[subjectIdIndex].options.map(v=>{
                        if(v.key === data[subjectIdIndex].value){
                            categoryIdOptions = v.children
                        }
                    })
                    const categoryIdIndex = this.$utils.getIndexByAttr({attr: 'category_id', data})
                    data[categoryIdIndex].options = categoryIdOptions
                    data[categoryIdIndex].value = []
                    // this.newData[category_id_index].form = data

                    const newData = this.$_.cloneDeepWith(this.newData)
                    newData[category_id_index].form = data
                    this.$emit('flashData', newData)
                    break
                }
                case 'category_id': {
                    // 分类改变后 通知服务端变更数据

                    const category_id_index = this.$utils.getIndexByAttr({attr: 'category_id', data: this.newData})
                    const data = this.$_.cloneDeepWith(this.newData[category_id_index].form)
                    const categoryIdIndex = this.$utils.getIndexByAttr({attr: 'category_id', data})
                    const arr = data[categoryIdIndex].value
                    let category_id = ''
                    if(arr && arr.length){
                        category_id = arr.pop()
                        this.$route.query.category_id = category_id
                        this.$store.state.initConfig.category_id = category_id
                        $eventBus.$emit('__save__',true,()=>{this.$message.success('编辑成功')}, [])
                    }
                    break
                }
                default:
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-box{
  padding: 0px 20px 0px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .title{
    font-size: 14px;
    color: #323232;
    margin-bottom: 12px;
  }
  .row-box{
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

      .input{
          width: 200px;
      }
  }
  .row{
    display: flex;
    line-height: 50px;
    width: 50%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

      &.fullLine{
          width: 100%;

          & /deep/ .select{
              display: flex;
              position: relative;
              left: -20px;
          }

          & /deep/ .el-form-item__label{
              color: #303133;
          }
      }

      .edit-box {
          .edit {
              font-size: 12px;
              margin-left: 10px;
              cursor: pointer;
          }
          .btns{
              margin-left: 10px;

              .save{
                  margin-right: 10px;
              }
              .btn{
                  cursor: pointer;

                  &:hover {
                      color: #facc00;
                  }
              }
          }
      }
      .select-box /deep/ .el-input__inner{
          width: 216px;
      }
      .select-box /deep/ .item{
          margin-bottom: 0px;
      }
      img.image{
          width: 100px;
          position: relative;
          top: 2px;
          margin-left: 10px;
      }
     .image{
       position: relative;
       top: 14px;
       left: -10px;
     }
    .name{
      max-width: 120px;
      font-size: 14px;
      color: #303133;
    }
    .img{
      width: 100px;
      height: 50px;
      object-fit: contain;
    }
    .value{
      font-size: 14px;
      color: #303133;
    }
  }
}
</style>
